import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.zentrale-pinnwand2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsZentralePinnwand2Effects {

    ZentralePinnwand2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ZENTRALE_PINNWAND2),
        mergeMap((x: ac.GetZentralePinnwand2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getZentralePinnwand2(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetZentralePinnwand2ErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetZentralePinnwand2FehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ZentraleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ZentraleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ZentraleQueryService);
        }
        return this.service;
    }
}
